import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as filters from './filters'
import {shareConfig} from './utils'

import 'style/base.scss'
import 'style/common.scss'

window.shareConfig = shareConfig

Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  ...App,
  store,
  router
}).$mount('#app')
